module.exports = __webpack_public_path__ + "img/reparation-marque.ed486aed.svg";